// extracted by mini-css-extract-plugin
module.exports = {"container":"ChannelDetails_container__2CMJM","title":"ChannelDetails_title__2L9RN","header":"ChannelDetails_header__HZcra","row":"ChannelDetails_row__tsO9q"};